import { ChevronDownIcon, ChevronUpIcon } from '@localina/icons';
import React from 'react';

interface ICollapseButtonProps {
    collapsed: boolean;

    onToggle: () => void;
    label?: string;
}

const CollapseButton = (props: ICollapseButtonProps) => (
    <span className="localina-collapse-button" onClick={props.onToggle} role="button" aria-label={props.label}>
        {props.collapsed ? <ChevronDownIcon /> : <ChevronUpIcon />}
    </span>
);

export default CollapseButton;
